module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart"
  }, [(_vm.chartData.type === 'bar') ? _c('bar-chart', {
    attrs: {
      "data": _vm.chartData,
      "index": _vm.chartIndex
    }
  }) : (_vm.chartData.type === 'pie') ? _c('pie-chart', {
    attrs: {
      "data": _vm.chartData
    }
  }) : (_vm.chartData.type === 'line') ? _c('line-chart', {
    attrs: {
      "data": _vm.chartData,
      "index": _vm.chartIndex
    }
  }) : (_vm.chartData.type === 'doughnut') ? _c('doughnut-chart', {
    attrs: {
      "data": _vm.chartData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f0ac390","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/chart/Chart.vue
// module id = 1769
// module chunks = 22